import type { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className="flex items-end justify-between gap-4 mb-7">
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-[11px] uppercase tracking-wider text-ink-tertiary font-medium mb-2">
            {eyebrow}
          </p>
        )}
        <h1 className="font-serif text-3xl md:text-4xl font-semibold tracking-tight text-ink-primary leading-tight">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-ink-secondary mt-1.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
